import { addPayment } from './addPayment';
import * as Client from './client';
import { consumeVerificationCode } from './consumeVerificationCode';
import { getEmailStatus } from './getEmailStatus';
import { getMedcards } from './getMedcards';
import { getPayments } from './getPayments';
import { login } from './login';
import { loginOrRegister } from './loginOrRegister';
import { removePayment } from './removePayment';
import { resendEmailVerification } from './resendEmailVerification';
import { updatePayment } from './updatePayment';
import { updateUserProfile } from './updateUserProfile';

export const AccountAPI = {
    login,
    loginOrRegister,
    getPayments,
    getEmailStatus,
    removePayment,
    resendEmailVerification,
    consumeVerificationCode,
    getMedcards,
    updateUserProfile,
    addPayment,
    Client,
    updatePayment,
};
